import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../css/header.css';
import video from "../../assest/video.mp4"

function Header() {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [lastClicked, setLastClicked] = useState('');

    const tabBar = {
        home: location.pathname === '/home',
        about: location.pathname === "/about",
        ourSer: location.pathname === "/home/all",
        contact: location.pathname === "/about/contactus"
    };

    const check = tabBar.about || tabBar.ourSer || tabBar.contact || false;

    const toggleMenu = (e) => {
        e.preventDefault();
        setIsMenuOpen(!isMenuOpen);
    };

    const handleNavigation = (e, path) => {
        e.preventDefault();
        setIsMenuOpen(false);
        setLastClicked(path);

        if (window.location.pathname === path) {
            setTimeout(() => {
                scrollToPosition();
            }, 300);
        } else {
            setTimeout(() => {
                window.location.href = path;
            }, 300);
        }
    };

    const scrollToPosition = () => {
        const isMobile = window.innerWidth <= 768;
        const scrollPosition = isMobile
            ? document.documentElement.scrollHeight / 4
            : document.documentElement.scrollHeight / 3;

        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        if (location.pathname.endsWith('about') || location.pathname.endsWith('contactus')) {
            setTimeout(() => {
                scrollToPosition();
            }, 300);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (lastClicked && (lastClicked === location.pathname)) {
            scrollToPosition();
        }
    }, [lastClicked, location.pathname]);

    return (
        <header>
            <div className={`nav ${isMenuOpen ? 'nav-active' : ''}`}>
                <div className={`menu ${isMenuOpen ? 'menu-hidden' : ''}`} onClick={toggleMenu}>
                    <span>
                        <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                            <path d="M4 6H20M4 12H20M4 18H20" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                </div>

                <ul className={`${isMenuOpen ? 'ul-active' : ''}`}>
                    <li><Link className={tabBar.home ? 'tab-barColor' : ''} to='/home' onClick={(e) => handleNavigation(e, '/home')}>الرئيسية</Link></li>
                    <li><Link className={tabBar.about ? 'tab-barColor' : ''} to='/about' onClick={(e) => handleNavigation(e, '/about')}>من نحن</Link></li>
                    <li><Link className={tabBar.ourSer ? 'tab-barColor' : ''} to='/home/all' onClick={(e) => handleNavigation(e, '/home/all')}>خدماتنا</Link></li>
                    <li><Link className={tabBar.contact ? 'tab-barColor' : ''} to='/about/contactus' onClick={(e) => handleNavigation(e, '/about/contactus')}>تواصل معنا</Link></li>
                </ul>

                <div className={`cancel ${isMenuOpen ? 'cancel-active' : ''}`} onClick={toggleMenu}>
                    <span>
                        <svg width="25px" height="25px" viewBox="0 0 512 512">
                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="work-case" fill="#000000" transform="translate(91.520000, 91.520000)">
                                    <polygon id="Close" points="328.96 30.2933333 298.666667 0 164.48 134.4 30.2933333 0 0 30.2933333 134.4 164.48 0 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"></polygon>
                                </g>
                            </g>
                        </svg>
                    </span>
                </div>
            </div>

            {/* الفيديو وطبقة الـ overlay يجب أن يكونا مباشرة داخل header */}
            <video className="background-video" autoPlay muted loop playsInline >
                <source src={video} type="video/mp4" />
            </video>
            <div className="overlay"></div>

            <div className="nav-c">
                <h1>خطوات المستثمر</h1>
                <h2>لماذا خطوة المستثمر؟</h2>
                <p>
                    عندما نصع أمامك كل الخيارات المتاحة للمسثمرين فإنك حتما ستختار <br />
                    خطوة المستثمر لتميز خدمتنا وابداعنا المتواصل. عندما تختارنا فإنك <br />
                    تختار الجودة والخبرة التى اختارتها أبرز الشركات في المملكة
                </p>
            </div>

            <div className="order-now">
                <Link to="https://api.whatsapp.com/send?phone=966547382666&text=السلام%20عليكم.%20اريد%20استفسر%20منك%20استاذ%20براء">اطلب الان &gt; &gt;</Link>
            </div>
        </header>
    );
}

export default Header;